<template>
  <v-row class="covered-wrapper">
    <v-col>
      <v-row class="app-container--width-max mx-auto">
        <v-col cols="12">
          <h2 class="mb-3">{{ title }}</h2>
          <p class="mb-2">
            {{ insuranceCoverDes }}
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <h3 class="font-24 d-flex align-center">
            <v-icon color="#1d8649" class="mr-2">mdi-check-circle</v-icon>What
            is usually covered?
          </h3>
          <ul>
            <li
              v-for="(item, index) in listCovered"
              :key="index"
              class="font-18"
            >
              {{ item?.text }}
            </li>
          </ul>
        </v-col>
        <v-col cols="12" lg="6">
          <h3 class="font-24 d-flex align-center flex-wrap">
            <v-icon color="var(--red-500)" class="mr-2">mdi-close-circle</v-icon
            >What&nbsp;
            <span class="text-decoration-underline">isn’t</span>
            &nbsp;usually covered?
          </h3>
          <ul>
            <li
              v-for="(item, index) in listNotCovered"
              :key="index"
              class="font-18"
            >
              {{ item?.text }}
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-btn @click="showFAQs" class="btn-view-faq" aria-label="View FAQs">
          VIEW FAQs
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { generateFAQSLink } from "@/common/navigating";
import {
  LIST_COVERED,
  LIST_NOT_COVERED,
} from "@/constants/d2c-landing-page.constants";
export default {
  name: "LandingPageWhatInsuranceCover",
  props: {
    title: {
      type: String,
      default: "What does home insurance cover?",
    },
    insuranceCoverDes: {
      type: String,
    },
    listCovered: {
      type: Array,
      default: () => LIST_COVERED,
    },
    listNotCovered: {
      type: Array,
      default: () => LIST_NOT_COVERED,
    },
  },
  methods: {
    showFAQs() {
      window.open(generateFAQSLink(), "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.covered-wrapper {
  background: #fff;
  padding: 43px 0 40px 0;
  ul {
    padding-left: 63px;
    li {
      padding-top: 25px;
      &::marker {
        font-size: 20px;
      }
    }
  }
}

.v-btn.btn-view-faq {
  background-color: #106175 !important;
  font-size: 18px !important;
  color: #fff !important;
  margin: auto;
  margin-top: 37px;
}
</style>
